import * as d3 from 'd3';
import { MarketMetadata } from '../../types';
import { RenderContext, ParsedChartPoint } from '../types';

interface SimpleModeConfig {
    parsedData: ParsedChartPoint[];
    markets: MarketMetadata[];
    marketColors: string[];
}

export function renderSimpleMode(ctx: RenderContext, config: SimpleModeConfig): void {
    const { g, scales } = ctx;
    const { parsedData, markets, marketColors } = config;

    // Line generator
    const line = d3.line<ParsedChartPoint>()
        .x(d => scales.x(d.parsedTimestamp))
        .curve(d3.curveMonotoneX)
        .defined(() => true);

    // Draw lines for each market
    markets.forEach((market, index) => {
        const marketLine = line.y(d => {
            const value = d[`market_${market.id}`];
            return value !== undefined && !isNaN(value) ? scales.y(value) : scales.y(50);
        });

        const marketData = parsedData.filter(d => {
            const value = d[`market_${market.id}`];
            return value !== undefined && !isNaN(value);
        });

        if (marketData.length > 0) {
            g.append('path')
                .datum(marketData)
                .attr('class', `market-line-${market.id}`)
                .attr('fill', 'none')
                .attr('stroke', marketColors[index])
                .attr('stroke-width', 2)
                .attr('stroke-opacity', 1)
                .attr('d', marketLine)
                .style('pointer-events', 'none');
        }
    });
}
